import { useTranslation } from 'react-i18next';
import { useKinds } from '@/api/objects';

/** Kind label in the active locale from the catalogue the API serves; falls back to the key. */
export function useKindLabel() {
  const { i18n } = useTranslation();
  const { data } = useKinds();
  return (kind: string) => data?.find((k) => k.kind === kind)?.label[i18n.language] ?? kind;
}
